// src/components/Login.js (Updated with Backend Integration & Redirect)
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Auth.css'; 

// URL for the Google Symbol SVG
const GOOGLE_ICON_URL = 'https://cdn.brandfetch.io/id6O2oGzv-/theme/dark/symbol.svg?c=1dxbfHSJFAPEGdCLU4o5B';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [passwordVisible, setPasswordVisible] = useState(false);
    const navigate = useNavigate(); // React Router hook for redirect

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!email || !password) {
            setError('Please enter both email and password.');
            return;
        }

        try {
            const res = await fetch('http://localhost:5000/api/users/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password }),
            });

            const data = await res.json();

            if (res.ok) {
                // Save JWT token to localStorage
                localStorage.setItem('token', data.token);
                localStorage.setItem('user', JSON.stringify(data.user));

                // Redirect to dashboard
                navigate('/dashboard');
            } else {
                setError(data.message || 'Invalid email or password');
            }
        } catch (err) {
            console.error(err);
            setError('Server error. Please try again later.');
        }
    };

    const handleGoogleLogin = () => {
        console.log('Redirecting to Google OAuth...');
        alert('Simulating Google Login!');
    }

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    return (
        <div className="auth-page section-padding">
            <div className="auth-form-container main-content">
                <Link to="/" className="auth-back-arrow">&larr;</Link>

                <h1 className="auth-heading">Welcome Back</h1>
                <p className="auth-subtext">Log in to continue your personalized journey.</p>

                {/* Social Login Section */}
                <div className="social-login-section">
                    <button 
                        onClick={handleGoogleLogin} 
                        className="btn-secondary google-login-btn"
                        type="button" 
                    >
                        <img src={GOOGLE_ICON_URL} alt="Google Symbol" className="google-icon" />
                        Log in with Google
                    </button>
                </div>

                <div className="divider"><span>or Log in with Email</span></div>

                <form onSubmit={handleSubmit} className="auth-form">
                    {error && <p className="auth-error-message">{error}</p>}
                    
                    <div className="form-group">
                        <label htmlFor="email" className="sr-only">Email</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            placeholder="Email *"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="password" className="sr-only">Password</label>
                        <div className="password-wrapper">
                            <input
                                type={passwordVisible ? 'text' : 'password'}
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                placeholder="Password *"
                            />
                            <span 
                                className="password-toggle-icon"
                                onClick={togglePasswordVisibility}
                            >
                                <i className={passwordVisible ? 'fas fa-eye-slash' : 'fas fa-eye'}></i>
                            </span>
                        </div>
                    </div>
                    
                    <button type="submit" className="btn-primary auth-submit-btn">
                        Log In
                    </button>
                </form>

                <div className="auth-footer center-text">
                    Don't have an account? <Link to="/signup" className="auth-link">Sign up here &rarr;</Link>
                </div>
            </div>
        </div>
    );
};

export default Login;
